import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  CLIENT_FORM_STEP_NAME,
  DEBTOR_FORM_STEP_NAME,
  PAYMENT_FORM_STEP_NAME,
  PAYMENT_REDIRECT_FORM_STEP_NAME,
} from 'src/app/services/form/form.service';

function caseFormTitleKey(step: string | null): string {
  switch (step) {
    case DEBTOR_FORM_STEP_NAME:
      return 'CASE_FORM.BROWSER_TITLE.DEBTOR';
    case CLIENT_FORM_STEP_NAME:
      return 'CASE_FORM.BROWSER_TITLE.CLIENT';
    case PAYMENT_FORM_STEP_NAME:
    case PAYMENT_REDIRECT_FORM_STEP_NAME:
      return 'CASE_FORM.BROWSER_TITLE.PAYMENT';
    default:
      return 'CASE_FORM.BROWSER_TITLE.DEBTOR';
  }
}

export const caseFormTitleResolver: ResolveFn<string> = (route) => {
  const translate = inject(TranslateService);
  return translate.stream(caseFormTitleKey(route.paramMap.get('step')));
};
